export const KEY_CODES = {
  BRACKET_CLOSING: 219, //клавиша "]"
  BRACKET_OPEN: 221, //клавиша "["
};
